/* eslint-disable */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Table, Modal, Button, Tooltip, TableContainer, TableBody, TableCell, TableRow, Typography, Alert } from '@mui/material';
import { ListHead, ListToolbar } from '../../sections/@dashboard/table';
import Label from "../Label";
import { getModalBoxStyle, invoiceDropOptions } from '../../utils/commonFunc';
import { TablePagination } from '@mui/material';
import { ARTICLE_NUMBERS, INVOICE_STATUS } from 'src/utils/constants';
import { toast } from 'react-toastify';
import { Snackbar, } from '@mui/material';
const REMINDERS_TABLE_HEAD = [
  { id: 'invoiceNumber', label: 'Invoice No', alignRight: false },
  { id: 'invoiceType', label: 'Invoice Type', alignRight: false },
  { id: 'customerName', label: 'Customer', alignRight: false },
  { id: 'originalInvoice', label: 'Original Invoice', alignRight: false },
  { id: 'createdBy', label: 'User Id', alignRight: false },
  { id: 'createdDate', label: 'Created Date', alignRight: false },
  { id: 'toPayAmount', label: 'Amount', alignRight: false },
  { id: 'invoiceStatus', label: 'Invoice Status', alignRight: false },
  { id: 'isActive', label: 'Actions', alignRight: false },
];

function ReminderInvoiceDataTable({ hideCheckboxColumnHeader, userId }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDropValue, setSearchDropValue] = useState();
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('createdDate');
  const [autoHideDuration, setAutoHideDuration] = useState(3000);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [originalInvoice, setoriginalInvoice] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [alertStatus, setAlertStatus] = useState('success');
  const [IstogglePaidUnpaid, setIstogglePaidUnpaid] = useState({
    id: null,
    show: false,
    type: '',
    invoiceNumber: null,
  });
  const [createAccountModal, setCreateAccountModal] = useState({
    id: null,
    invoiceNumber: null,
    show: false,
    type: '',
  });


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchInvoices();
    }, 600);
    return () => clearTimeout(timeoutId);
  }, [page, rowsPerPage, searchQuery]);

  function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis?.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const handleFilter = (event) => {
    setSearchQuery(event.target.value);
    if (event.target.value) {
      const filteredRows = applySortFilter(
        filteredInvoices,
        getComparator(order, orderBy),
        event.target.value,
        originalInvoice
      );

      setFilteredInvoices(filteredRows);
    } else {
      setFilteredInvoices(originalInvoice);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    const filteredRows = applySortFilter(
      filteredInvoices,
      getComparator(isAsc ? 'desc' : 'asc', orderBy),
      event.target.value,
      originalInvoice
    );
    setFilteredInvoices(filteredRows);
  };

  const handleDelete = async () => {
    await cancelInvoice();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      let URL;
      if (searchDropValue && searchQuery) {
        URL = `/AdminReminderInvoice?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&searchQuery=${searchQuery}&SearchColumn=${searchDropValue}`;
      }
      else if(userId){
         URL = `/AdminReminderInvoice?PageSize=${rowsPerPage}&PageNumber=${page + 1}&searchQuery=${userId}&SearchColumn=${6}`;
      } else {
        URL = `/AdminReminderInvoice?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&searchQuery=${searchQuery}`;
      }
      const res = await axios.get(URL);

  if (res?.status === 200) {
  const invoices = (res.data.response || [])
     .map(invoice => ({
      ...invoice,
      createdDate: invoice.createdDate?.split('T')[0] || ''
    }));
  setInvoices(invoices);
  setTotalCount(res.data.totalCount);
}
    } catch (error) {
      console.error('Error fetching invoices:', error);
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

   const handlePaidSalary = async (data) => {
      const { invoiceNumber, type } = data;
    
      try {
        setLoading(true);
    
        let url;
        let payload = null;
    
        if (type === 'unpaid') {
          url = `/admin/invoice/changes-in-status-of-invoice?invoiceNumber=${invoiceNumber}`;
        } else if (type === 'paid') {
          payload = {
            InvoiceNumbers: [invoiceNumber],
            IsPaid: true,
          };
          url = `/admin/adminSalary/create-salary`;
        }
    
        if (url) {
        const result = await axios.post(url, payload);
        if (result?.data?.statusCode === 200) {
          setAlertMessage(`Invoice has been ${type === 'unpaid' ? 'unpaid' : 'paid'} successfully.`);
          setAlertStatus('success');
          setIsSnackBarOpen(true);
          await fetchInvoices();
        } else {
          setAlertMessage(result?.data?.message || 'Failed to update invoice status');
          setAlertStatus('error');
          setIsSnackBarOpen(true);
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'An error occurred';
      setAlertMessage(errorMessage);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusClick = (invoice, type) => {
    if (!invoice?.isSalaryStatusUpdatedManually) {
      setIstogglePaidUnpaid({
        id: invoice.id,
        show: true,
        type,
        invoiceNumber: invoice.invoiceNumber,
      });
    }
  };

  const cancelInvoice = async (invoiceNumber) => {
    try {
      setLoading(true);
      const result = await axios.put(`/admin/invoice/${invoiceNumber}?isActive=false`);
      if (result?.data?.statusCode === 200 ) {
        setAlertMessage('Invoice has been cancelled successfully.');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        await fetchInvoices();
      } else {
        setAlertMessage(result?.data?.message || 'Failed to cancel invoice');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      console.log(err);
      const errorMessage = err?.response?.data?.message || err?.message || 'Failed to cancel invoice';
      setAlertMessage(errorMessage);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleSnackBarClose = () => {
    setIsSnackBarOpen(false);
  };

  return (
    <>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isSnackBarOpen}
        autoHideDuration={autoHideDuration}
        onClose={handleSnackBarClose}
      >
        <Alert onClose={handleSnackBarClose} severity={alertStatus} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      {!userId && (
      <ListToolbar
        hideEmailButton={'true'}
        searchQuery={searchQuery}
        onFilter={handleFilter}
        onDelete={handleDelete}
        dropOptions={invoiceDropOptions}
        searchDropValue={searchDropValue}
        setSearchDropValue={setSearchDropValue}
      />
      )}
      <TableContainer sx={{ minWidth: 800 }}>
        <Table className="invoice-details">
                    <ListHead headLabel={REMINDERS_TABLE_HEAD} hideCheckboxColumnHeader={hideCheckboxColumnHeader} onRequestSort={handleRequestSort} />
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            )}
            {invoices.length > 0 &&
              invoices.map((invoice) => (
                <TableRow key={invoice.invoiceNumber}>
                  <TableCell align="left">{invoice.invoiceNumber}</TableCell>
                  <TableCell align="left">{invoice.invoiceType === 2 ? 'E-invoice' : invoice.invoiceType === 3 ? 'Post' : 'Email'}
                  </TableCell>
                  <TableCell align="left">{invoice.customer.name?.substring(0, 9).concat('...')}
                  </TableCell>
                  <TableCell align="left">
                    <a href={invoice.originalInvoice} target="_blank" rel="noopener noreferrer">
                      {invoice.reminderInvoiceNumber || 'N/A'}
                    </a>
                  </TableCell>
                  <TableCell align="left">{invoice.createdBy}</TableCell>
                  <TableCell align="left">{invoice.createdDate}</TableCell>
                  <TableCell align="left">{invoice.toPayAmont}</TableCell>

                  <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                    {invoice.invoiceStatus && (
                      <div variant="ghost" >
                        {invoice.invoiceStatus === INVOICE_STATUS.UNPAID ? (
                          <span
                            style={{ cursor: invoice?.isSalaryStatusUpdatedManually ? 'auto' : 'pointer', backgroundColor: "#ffe2e1", padding: "5px 10px", borderRadius: "5px", color: "#B72136", fontSize: "0.75rem", fontWeight: "700" }}

                            onClick={() => {
                              !invoice?.isSalaryStatusUpdatedManually &&
                                setIstogglePaidUnpaid({
                                  id: invoice.id,
                                  show: true,
                                  type: 'paid',
                                  invoiceNumber: invoice.invoiceNumber,
                                });
                            }}
                          >
                            Unpaid
                          </span>
                        ) : invoice.invoiceStatus === INVOICE_STATUS.PAID ? (
                          <span
                            style={{ cursor: 'pointer', backgroundColor: "rgba(53, 140, 118, 0.16)", padding: "5px 10px", borderRadius: "5px", color: "rgb(37, 98, 82)", fontSize: "0.75rem", fontWeight: "700" }}
                            onClick={() => {
                              setIstogglePaidUnpaid({
                                id: invoice.id,
                                show: true,
                                type: 'unpaid',
                                invoiceNumber: invoice.invoiceNumber,
                              });
                            }}
                          >
                            {'Paid'}
                          </span>
                        ) : (
                          <span className='invoice_clr' style={{ background: '#FFF3CD', padding: "5px 10px", borderRadius: "5px", color: "#856404", fontSize: "0.75rem", fontWeight: "700" }}>
                            Partial
                          </span>
                        )}
                      </div>
                    )}
                  </TableCell>
                  <TableCell align="left" style={{ display: 'flex' }}>
                    <Tooltip title="Cancel">
                      <Button
                        variant="outlined"
                        color={'error'}
                        style={{
                          width: 50,
                          minWidth: '50px',
                          fontSize: '12px',
                        }}

                        onClick={() => {
                          setCreateAccountModal({
                            id: invoice.id,
                            invoiceNumber: invoice.invoiceNumber,
                            show: true,
                            type: 'cancel',
                          });
                        }}
                      >
                        <CancelIcon style={{ color: 'rgb(195,65,82)' }}>Cancel</CancelIcon>
                      </Button>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            {invoices.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No invoices found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={createAccountModal.show}
        onClose={() => setCreateAccountModal({ show: false })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={getModalBoxStyle()}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to cancel?
          </Typography>
          <div
            style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
          >
            <Button
              onClick={() => setCreateAccountModal({ show: false })}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              No
            </Button>
            <Button
              onClick={() => {
                cancelInvoice(createAccountModal.invoiceNumber);
                setCreateAccountModal({ ...createAccountModal, show: false });
              }}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={IstogglePaidUnpaid.show}
        onClose={() => setCreateAccountModal({ show: false })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={getModalBoxStyle()}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {IstogglePaidUnpaid.type === 'paid' && 'Are you sure you want to mark invoice as Paid?'}
            {IstogglePaidUnpaid.type === 'unpaid' && 'Are you sure you want to mark invoice as Unpaid?'}
          </Typography>
          <div style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}>
            <Button
              onClick={() => setIstogglePaidUnpaid({ show: false })}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              No
            </Button>
            <Button
              onClick={() => {
                if (IstogglePaidUnpaid.type === 'paid' || IstogglePaidUnpaid.type === 'unpaid') {
                  handlePaidSalary(IstogglePaidUnpaid);
                }
                setIstogglePaidUnpaid({ ...IstogglePaidUnpaid, show: false });
              }}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>

      <TablePagination
        rowsPerPageOptions={[50, 100, 250, 500]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default ReminderInvoiceDataTable;
